import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActionSheetController, AlertController, ToastController } from '@ionic/angular';
import { ReportsDTO } from 'src/app/admin/admin.dto';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class ReportService {

    private REASONS = [
        { id: 'spam', label: 'Spam / Irrelevant' },
        { id: 'inappropriate', label: 'Inappropriate / Offensive' },
        { id: 'hate', label: 'Hate Speech / Discrimination' },
        { id: 'harassment', label: 'Harassment / Bullying' },
        { id: 'misinformation', label: 'Misinformation / False Info' },
        { id: 'animal_abuse', label: 'Animal Abuse / Harmful Content' },
        { id: 'illegal', label: 'Illegal Activity' },
        { id: 'scam', label: 'Scam / Fraud' },
        { id: 'other', label: 'Other…' },
    ];
    constructor(
        private actionSheetCtrl: ActionSheetController,
        private alertCtrl: AlertController,
        private toastCtrl: ToastController,
        private http: HttpClient,
    ) { }

    async report(type: string, id: string, userid: number) {
        const sheet = await this.actionSheetCtrl.create({
            buttons: [
                ...this.REASONS.map(r => ({
                    text: r.label,
                    handler: () => {
                        if (r.id === 'other') {
                            // Keep sheet open while we ask for custom note
                            this.askOther().then(async note => {
                                if (note !== null) {
                                    await this.callApi(type, id, note, userid, note).subscribe(() => this.okToast());;
                                    sheet.dismiss(); // close after success
                                }
                            });
                            return false; // do not auto-dismiss
                        }
                        // Normal reasons: call API and close
                        this.callApi(type, id, r.id, userid).subscribe(() => this.okToast());
                        return true; // auto-dismiss
                    }
                })),
                { text: 'Cancel', role: 'cancel' }
            ]
        });

        await sheet.present();
    }

    private async askOther(): Promise<string | null> {
        const alert = await this.alertCtrl.create({
            header: 'Other reason',
            inputs: [{ name: 'note', type: 'textarea', placeholder: 'Type your reason…' }],
            buttons: [
                { text: 'Cancel', role: 'cancel' },
                {
                    text: 'Submit',
                    handler: (data: any) => {
                        const v = (data?.note ?? '').trim();
                        if (!v) return false; // keep alert open if empty
                        (alert as any)._note = v;
                        return true;
                    }
                }
            ]
        });
        await alert.present();
        const res = await alert.onDidDismiss();
        return res.role === 'cancel' ? null : ((alert as any)._note as string);
    }

    private callApi(type: string, id: string, reason: string, userId: number, note?: string) {
        const url =
            environment.apiUrl +
            '/api/account/report/'
        return this.http.post<Boolean>(url, { type, id, reason, note, userId });
    }

    private async okToast() {
        const t = await this.toastCtrl.create({
            message: 'Thanks! We’ll review this.',
            duration: 1600,
            position: 'bottom',
            color: 'primary',
        });
        await t.present();
    }


    getReports() {
        const url =
            environment.apiUrl +
            '/api/admin/reports'
        return this.http.get<ReportsDTO[]>(url);
    }

    markAsHandled(reportId: number) {
        const url =
            environment.apiUrl +
            '/api/admin/report/handled/' + reportId;
        return this.http.post<Boolean>(url, {});
    }

    deleteReport(reportId: number) {
        const url =
            environment.apiUrl +
            '/api/admin/report/delete/' + reportId;
        return this.http.delete<Boolean>(url)
    }

}
